import { gql } from '@apollo/client'
import { PlanetLiteFragment } from '@src/graphql/fragment/planet'
import {
  StarLiteFragment,
  StarSuperLiteFragment
} from '@src/graphql/fragment/star'

export const OrbitalTrackSettingFragment = gql`
  fragment OrbitalTrackSetting on OrbitalTrackSetting {
    canBeRenew
    currencyCode
    currencyCodeDecimal
    groupName
    inviteAddressList
    inviteGroupId
    maxCountForEachAddress
    occupiedTrack
    priority
    rentalDuration
    rentalFee
    totalTrack
  }
`

export const OrbitalTrackLiteFragment = gql`
  fragment OrbitalTrackLite on StarOrbitalTrack {
    attachedPlanetId
    availableTrackTime
    orbitalTrackState
    originalRentalStartTime
    planetOwnerAddress
    renewable
    rentalEndTime
    rentalFee
    rentalFeeAfterPlatform
    rentalStartTime
    slotIndex
    starID
    tier
    totalAgingBuff
    totalTrackCount
    attachedPlanet {
      ...PlanetLite
    }
    setting {
      ...OrbitalTrackSetting
    }
    star {
      ...StarLite
    }
  }

  ${StarLiteFragment}
  ${PlanetLiteFragment}
  ${OrbitalTrackSettingFragment}
`

export const PublicStarRentalLiteFragment = gql`
  fragment PublicStarRentalLite on StarOpenRentOrbitalTrack {
    availableTrackCount
    canBeRenew
    currencyCode
    currencyCodeDecimal
    occupiedTrackCount
    rentalDuration
    rentalFee
    totalAgingBuff
    star {
      ...StarSuperLite
    }
  }

  ${StarSuperLiteFragment}
`

export const PublicStarRentalFragment = gql`
  fragment PublicStarRental on StarOpenRentOrbitalTrack {
    isOpenRentGroup
    inviteGroupID
    starID
    ...PublicStarRentalLite
  }

  ${PublicStarRentalLiteFragment}
`
